import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import StatusPill from "@/components/StatusPill";
import { Button } from "@/components/ui/button";
import { TID } from "@/lib/testIds";
import api from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpRight, Copy, Plus, BookmarkSimple } from "@phosphor-icons/react";

export default function Requests() {
  const [items, setItems] = useState([]);
  const [icps, setIcps] = useState([]);
  const load = async () => { const { data } = await api.get("/requests"); setItems(data.items || []); };
  useEffect(() => {
    load();
    api.get("/icps").then((r) => setIcps(r.data.items || []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const duplicate = async (id) => { await api.post(`/requests/${id}/duplicate`); toast.success("Duplicated"); load(); };
  const saveAsIcp = async (id, title) => {
    const name = window.prompt("Name this ICP:", title);
    if (!name) return;
    await api.post("/icps", { name, source_request_id: id });
    toast.success("Saved to ICPs");
    api.get("/icps").then((r) => setIcps(r.data.items || []));
  };

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Requests</div>
            <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl">Your audience requests.</h1>
          </div>
          <Link to="/new-request"><Button className="rounded-sm"><Plus size={14} className="mr-2" /> New request</Button></Link>
        </div>
        {items.length === 0 && <div className="text-sm text-muted-foreground">No requests yet.</div>}
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.request_id} className="border border-border p-5 bg-white flex items-center justify-between gap-4">
              <Link to={`/requests/${r.request_id}`} className="flex-1 min-w-0" data-testid={`requests-card-${r.request_id}`}>
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-mono text-[11px] text-muted-foreground">{r.reference}</span>
                  <StatusPill status={r.status} />
                </div>
                <div className="font-semibold text-base truncate">{r.title}</div>
                <div className="text-xs text-muted-foreground mt-1">Created {new Date(r.created_at).toLocaleDateString()}</div>
              </Link>
              <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" className="rounded-sm" onClick={() => saveAsIcp(r.request_id, r.title)} data-testid={`requests-save-icp-${r.request_id}`}>
                  <BookmarkSimple size={14} className="mr-1" /> Save ICP
                </Button>
                <Button size="sm" variant="outline" className="rounded-sm" onClick={() => duplicate(r.request_id)} data-testid={`requests-duplicate-${r.request_id}`}>
                  <Copy size={14} className="mr-1" /> Duplicate
                </Button>
                <Link to={`/requests/${r.request_id}`} className="text-primary text-sm inline-flex items-center gap-1 hover:underline">
                  Open <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
